import { render, staticRenderFns } from "./playground.vue?vue&type=template&id=404ffeaa&lang=pug&"
import script from "./playground.vue?vue&type=script&lang=js&"
export * from "./playground.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports